import { z } from 'zod';

export const registerSchema = z
  .object({
    firstName: z.string().min(1, 'components.form.validation.required'),
    lastName: z.string().min(1, 'components.form.validation.required'),
    email: z.string().min(1, 'components.form.validation.required').email('components.form.validation.email'),
    phoneNumber: z.string().min(1, 'components.form.validation.required'),
    password: z.string().min(6, 'pages.register.validation.password_min_length'),
    confirmPassword: z.string().min(1, 'components.form.validation.required'),
    subscribeNewsletter: z.boolean(),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: 'pages.register.validation.passwords_must_match',
    path: ['confirmPassword'],
  });

export type RegisterFormValues = z.infer<typeof registerSchema>;
